const STORAGE_KEY = 'ytgp_job_list_back';

const initJobListBackLinks = (): void => {
	document.querySelectorAll<HTMLAnchorElement>('.js-job-list-link[data-back-url]').forEach((link) => {
		link.addEventListener('click', () => {
			const backUrl = link.dataset.backUrl;
			if (backUrl) {
				sessionStorage.setItem(STORAGE_KEY, backUrl);
			}
		});
	});
};

const initJobDetailBackLink = (): void => {
	const backLink = document.querySelector<HTMLAnchorElement>('.js-job-back-link');
	const backRow = document.querySelector<HTMLElement>('.js-job-back-row');

	if (!backLink || !backRow) {
		return;
	}

	const backUrl = sessionStorage.getItem(STORAGE_KEY);
	if (!backUrl) {
		return;
	}

	backLink.href = backUrl;
	backRow.hidden = false;
};

initJobListBackLinks();
initJobDetailBackLink();
